import { useEffect, useState } from "react";
import OgnRequest from "src/models/Base/Auth/OgnRequest";
import { useLazyOgnLoginQuery } from "src/services/Auth/AuthApi";
import { useAppDispatch, useAppSelector } from "src/store";
import AuthSlice from "src/store/slices/Auth/AuthSlice";
import { Button } from "src/components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import GnlKullaniciDTO from "src/models/IdariTanim/KullaniciDTO";

export interface IOgnResponse {
    code?: string;
    scope?: string;
    state?: string;
    session_state?: string;
}

const OgnLogin = (): JSX.Element => {
    const userState = useAppSelector(s => s.userLogin)
    const dispatch = useAppDispatch();
    const [lazyQuery, lazyQueryState] = useLazyOgnLoginQuery()
    const [location] = useState(window.location)
    const navigate = useNavigate();
    useEffect(() => {
        const tanimliAdresler = ["https://testlbys.saglik.gov.tr", "https://lbysv2.saglik.gov.tr"];
        if (!tanimliAdresler.includes(window.location.origin, 0))
            return;
        if (location.search) {
            //Prevent Prototype Pollution
            const queryString = window.location.search;
            const params = new URLSearchParams(queryString);
            const code = params.get("code");
            if (!code)
                return;
            const state = params.get("state")
            //
            console.log(code)
            lazyQuery({
                code: code,
                ognGiris: true,
                state: state,
                uygulamaKodu: ""
            })
                .unwrap()
                .then(res => {
                    dispatch(AuthSlice.actions.setState({
                        ...userState,
                        isButtonDisabled: true,
                        userInfo: res,
                        isLoggedIn: res.kullaniciId > 0,
                        captchaKodu: "",
                        hataSayi: 0,
                        captchaHelpertext: "",
                        captchaId: null,
                        ogn: true
                    }))
                    navigate("/");
                })
        }
    }, [location])
    const { t } = useTranslation();
    const onOgnClickHandler = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        const res = await lazyQuery({
            ...new OgnRequest(),
            ognGiris: false
        }).unwrap()
        window.location.href = res.ognUrl;
    }

    return (
        <Button loading={lazyQueryState.isFetching}
            onClick={onOgnClickHandler}
        >{t('pages|login|ogn', 'Ortak Giriş Noktası')}</Button>
    )
}
export default OgnLogin;